"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.XemelgoConfigClientV2 = exports.XemelgoConfigClientV1 = void 0;
var aws_amplify_1 = __importStar(require("aws-amplify"));
var config_client_1 = require("./clients/config-client");
var client_cache_1 = require("./clients/client-cache");
var XemelgoConfigClientV1 = /** @class */ (function () {
    function XemelgoConfigClientV1(endpointConfigs, retrieveTokenFunc, authorizationToken) {
        var endpointName = 'XemelgoConfigurationService';
        // cache the authorization token, which are used in the request's headers
        if (authorizationToken) {
            client_cache_1.cache.authorizationToken = authorizationToken;
        }
        else {
            client_cache_1.cache.authorizationToken = retrieveTokenFunc();
        }
        // configure Amplify's API
        aws_amplify_1.API.configure({
            endpoints: endpointConfigs,
        });
        this.configClient = new config_client_1.ConfigClientV1(endpointName, retrieveTokenFunc);
    }
    XemelgoConfigClientV1.prototype.getConfigClient = function () {
        return this.configClient;
    };
    return XemelgoConfigClientV1;
}());
exports.XemelgoConfigClientV1 = XemelgoConfigClientV1;
var XemelgoConfigClientV2 = /** @class */ (function () {
    function XemelgoConfigClientV2(authConfig, endpointConfigs) {
        var endpointName = 'XemelgoConfigurationService';
        // configure Amplify's API
        var config = {
            Auth: authConfig,
            API: {
                endpoints: endpointConfigs
            }
        };
        aws_amplify_1.default.configure(config);
        this.configClient = new config_client_1.ConfigClientV2(endpointName);
    }
    XemelgoConfigClientV2.prototype.getConfigClient = function () {
        return this.configClient;
    };
    return XemelgoConfigClientV2;
}());
exports.XemelgoConfigClientV2 = XemelgoConfigClientV2;
//# sourceMappingURL=xemelgo-config-client.js.map